import {NotificationRepo} from "../api/notification.repo";
import {Injectable} from "@angular/core";
import {OrgDto} from "../dto/org.dto";
import {Observable} from "rxjs";
import {WrapperDto} from "../dto/wrapper.dto";
import {NotificationDto} from "../dto/notification.dto";
import {DuckDbHelper} from "./duckdb.helper";
import {VoidDto} from "../dto/void.dto";

@Injectable({providedIn: 'root'})
export class NotificationDuckDb extends NotificationRepo {

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public override getAll(_org: OrgDto): Observable<WrapperDto<NotificationDto>> {
    return DuckDbHelper.datasObs('NotificationDto', []);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public override markAsRead(_org: OrgDto, _notificationId: string): Observable<WrapperDto<VoidDto>> {
    return DuckDbHelper.voidObs();
  }
}
